module.exports = "@page {\n  size: landscape;\n  margin: 0; }\n\n.AgentList {\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n          flex-grow: 1; }\n"